<template>
  <div>
    <record-import :showImportDialog="showImportDialog" :patientID="patient.id" @closeImportDialog="showImportDialog = false" @importRecord="readRecord"></record-import>
    <confirm-remove :showRemoveDialog="showRemoveDialog" @confirm="removeRecord" @close="showRemoveDialog = false"></confirm-remove>
    <add-patient :showAddPatientDialog="showAddPatientDialog" @addPatient="addPatient" @close="showAddPatientDialog = false"></add-patient>
    <use-template :showUseTemplateDialog="showUseTemplateDialog" @useTemplate="useTemplate" @close="showUseTemplateDialog = false"></use-template>
    <md-card class="card-container" v-if="isLoaded">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="isEditing ? '修改紀錄' : '新增紀錄'"></page-title>
        </div>
        <div class="md-layout-item float-right" v-if="hasScope('RECORD_UPSERT')">
          <md-button v-if="isEditing && canEdit" class="md-raised md-accent float-right" @click="showRemoveDialog = true">刪除紀錄</md-button>
          <md-button class="md-raised md-primary float-right" @click="showImportDialog = true">導入紀錄</md-button>
          <md-button class="md-raised md-primary float-right" @click="popupPatientInfo">檢視客戶資訊</md-button>
          <md-button class="md-raised md-primary float-right" @click="showUseTemplateDialog = true">導入服務範本</md-button>
        </div>
      </div>
      <div>
        <md-tabs :md-dynamic-height="true">
          <md-tab md-label="紀錄區">
            <div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label>姓名</label>
                    <md-input v-model="data.patient.name" disabled></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label>客戶編號</label>
                    <md-input v-model="data.patient.id_alt" disabled></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-datepicker v-model="selectedDate">
                    <label>掛號日期</label>
                  </md-datepicker>
                </div>
                <div class="md-layout-item">
                    <time-range :date="selectedDate" :time="selectedStartTime" @change="updateRegAt"></time-range>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label>治療師</label>
                    <!-- <label>治療師 (now: {{getDocName(data.doctor.id)}})</label> -->
                    <md-select v-model="data.doctor.id">
                      <md-option v-for="(doctor, index) in doctors" :doctors="doctors" :key="doctor.id" :value="doctor.id">{{doctor.name}}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-field>
                    <label>看診地點</label>
                    <!-- <label>看診地點 (now: {{getLocName(data.location.id)}})</label> -->
                    <md-select v-model="data.location.id">
                      <md-option v-for="(location, index) in locations" :locations="locations" :key="location.id" :value="location.id">{{location.name}}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label>服務紀錄</label>
                    <md-textarea v-model="data.content"></md-textarea>
                  </md-field>
                </div>
              </div>
              <div v-for="(usage, index) in data.usage">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <md-field>
                      <label>服務名稱</label>
                      <md-input v-model="usage.item.name" disabled></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field>
                      <label>使用數量</label>
                      <md-input v-model="usage.quantity"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-button class="md-raised md-accent" @click="removeItem(index)">移除</md-button>
                  </div>
                </div>
              </div>
              <md-divider></md-divider>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label for="item">新增服務名稱</label>
                    <md-select name="item" id="item" v-model="selectedItem">
                      <md-option v-for="item in items" :items="items" :key="item.id" :value="item.id">{{item.name}}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item">
                  <md-button class="md-raised md-primary" @click="addItem">新增服務</md-button>
                </div>
              </div>
            </div>
          </md-tab>
          <md-tab md-label="複製紀錄" v-if="isEditing">
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-table>
                  <md-table-row>
                    <md-table-head>姓名</md-table-head>
                    <md-table-head>客戶編號</md-table-head>
                    <md-table-head></md-table-head>
                  </md-table-row>
                  <md-table-row v-for="(patient, index) in data.duplicate" :key="patient.id">
                    <md-table-cell>
                      {{patient.name}}
                    </md-table-cell>
                    <md-table-cell>
                      {{patient.id_alt}}
                    </md-table-cell>
                    <md-table-cell>
                      <a @click="removeDuplicate(index)">
                        移除
                      </a>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
            </div>
            <md-divider></md-divider>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-button class="md-raised md-primary" @click="showAddPatientDialog = true">新增客戶</md-button>
              </div>
            </div>
          </md-tab>
          <md-tab md-label="檔案">
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-table>
                  <md-table-row>
                    <md-table-head>檔名</md-table-head>
                    <md-table-head></md-table-head>
                  </md-table-row>
                  <md-table-row v-for="(file, index) in data.file" :key="index">
                    <md-table-cell>
                      <a :href="file.url" target="_blank">
                        {{file.filename}}
                      </a>
                    </md-table-cell>
                    <md-table-cell>
                      <a @click="removeFile(index)">
                        移除
                      </a>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
            </div>
            <md-divider></md-divider>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field>
                  <label>檔案上傳</label>
                  <md-file v-model="file" @md-change="uploadFile"></md-file>
                </md-field>
              </div>
            </div>
          </md-tab>
          <md-tab md-label="ORS 測試">
            <ors :recordID="isEditing" :patientID="data.patient.id"></ors>
          </md-tab>
        </md-tabs>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-button class="md-raised md-danger" @click="$router.back()">返回</md-button>
            <md-button v-if="isEditing && hasScope('RECORD_EXPORT_RECEIPT')" class="md-raised md-primary" @click="getReceipt">匯出收據</md-button>
            <md-button v-if="isEditing && hasScope('RECORD_EXPORT_PROOF')" class="md-raised md-primary" @click="getProof">匯出就醫證明</md-button>
            <md-button v-if="isEditing && hasScope('RECORD_EXPORT')" class="md-raised md-primary" @click="getExport">匯出服務紀錄</md-button>
          </div>
          <div class="md-layout-item float-right">
            <div v-if="hasScope('RECORD_UPSERT') && canEdit">
              <md-button v-if="isEditing" class="md-raised md-primary float-right" @click="editRecord">送出</md-button>
              <md-button v-else class="md-raised md-primary float-right" @click="createRecord">送出</md-button>
            </div>
            <md-checkbox v-model="data.is_completed" class="float-right">完成紀錄</md-checkbox>
          </div>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import TimeRange from '@/components/Shared/TimeRange'
import ConfirmRemove from '@/components/Shared/ConfirmRemove'
import RecordImport from '@/components/Record/RecordImport'
import AddPatient from '@/components/Record/AddPatient'
import UseTemplate from '@/components/Record/UseTemplate'
import axios from 'axios'
import moment from 'moment'
import ors from '@/components/ORSTest/ORS'
import { mapMutations, mapState } from 'vuex'
import urls from '@/urls'
import { hasScope } from '@/services/auth'
import store from '@/store'

export default {
  store,
  data () {
    return {
      isEditing: null,
      isLoaded: false,
      selectedDate: null,
      selectedStartTime: null,
      showImportDialog: false,
      showRemoveDialog: false,
      showAddPatientDialog: false,
      showUseTemplateDialog: false,
      // doctorIndex: 0,
      // locationIndex: 0,
      test: null,
      file: null,
      data: {
        registered_at: [],
        patient: [{}],
        content: '',
        doctor: {
          id: null
        },
        location: {
          id: null
        },
        usage: [],
        duplicate: [],
        file: [],
        is_completed: false
      },
      selectedItem: null,
      selectedPatient: null,
      locations: [],
      doctors: [],
      items: [],
      patients: []
    }
  },
  components: {
    PageTitle, ors, TimeRange, RecordImport, ConfirmRemove, AddPatient, UseTemplate
  },
  created: async function () {
    await Promise.all([
      this.getLocation(),
      this.getDoctor(),
      this.getItem(),
      this.getPatient()
    ])
    if (this.$route.params.id !== 'add') {
      this.isEditing = this.$route.params.id
    }
    if (this.isEditing) {
      await this.readRecord(this.isEditing)
    } else {
      this.data.patient = this.patient
      this.resetOrsValues()
    }
    this.isLoaded = true
  },
  computed: {
    ...mapState('patient', {
      patient: 'content'
    }),
    ...mapState('ors', {
      ors: 'content'
    }),
    canEdit: function () {
      if (!this.isEditing || hasScope('RECORD_EDIT_ALL')) {
        return true
      }
      return this.data.doctor.id === this.$store.state.auth.user.id
    }
  },
  methods: {
    hasScope,
    async uploadFile (event) {
      store.commit('snackbar/FILE_UPLOADING')
      let file = event[0]
      let creds = await axios.post(urls({route: 'record/photo-upload'}), {filename: file.name, contentType: file.type})
      let upload = await axios.put(creds.data.data.signedRequest, file, {
        transformRequest: [(data, headers) => {
          delete headers.common.Authorization
          return data
        }],
        headers: {
          'Content-Type': file.type
        }
      })
      if (upload && upload.status === 200) {
        this.data.file.push({
          url: creds.data.data.url,
          filename: file.name
        })
      }
      store.commit('snackbar/HIDE')
    },
    ...mapMutations('ors', {
      loadOrsValues: 'loadValues',
      resetOrsValues: 'resetValues'
    }),
    removeFile (index) {
      this.data.file.splice(index, 1)
    },
    removeItem (index) {
      this.data.usage.splice(index, 1)
    },
    removeDuplicate (index) {
      this.data.duplicate.splice(index, 1)
    },
    addPatient (patient) {
      if (this.data.duplicate.find(i => i.id === patient.id)) {
        return
      }
      this.data.duplicate.push({
        id: patient.id,
        id_alt: patient.id_alt,
        name: patient.name
      })
    },
    addItem () {
      if (!this.selectedItem) {
        return
      }
      let itemID = this.selectedItem
      // let targetItem
      for (var i in this.items) {
        if (this.items[i].id === itemID) {
          let targetItem = this.items[i]
          this.data.usage.push({
            item_id: targetItem.id,
            item: {
              name: targetItem.name
            },
            quantity: null
          })
          break
        }
      }
    },
    updateRegAt (val) {
      this.data.registered_at = val
    },
    goRecordList () {
      this.$router.push('/record')
    },
    getLocation: async function () {
      let req = await axios.get(urls({route: 'location'}))
      this.locations = req.data.data
      // this.getLocName()
    },
    getPatient: async function () {
      let req = await axios.get(urls({route: 'patient'}))
      this.patients = req.data.data
    },
    getItem: async function () {
      let req = await axios.get(urls({route: 'item'}))
      this.items = req.data.data
    },
    getDoctor: async function () {
      let req = await axios.get(urls({route: 'user'}), {
        params: {
          role_name: '治療師',
          limit: 100
        }
      })
      this.doctors = req.data.data
      // this.getDocName()
    },
    removeRecord: async function () {
      let req = await axios.delete(urls({route: 'record', id: this.isEditing}))
      if (req.status === 200) {
        this.goRecordList()
      }
    },
    createRecord: async function () {
      let req = await axios.post(urls({route: 'record'}), {
        ...this.data,
        ors_test: {
          content: {
            ...this.ors,
            personal: this.ors.personal / 10,
            interpersonal: this.ors.interpersonal / 10,
            social: this.ors.social / 10,
            overall: this.ors.overall / 10
          }
        }
      })
      if (req.status === 201) {
        this.goRecordList()
      }
    },
    getProof: function () {
      axios({
        method: 'get',
        url: urls({route: `record/${this.isEditing}/proof`}),
        responseType: 'blob'
      }).then(function (resp) {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(resp.data)
        link.download = '匯出就醫證明.docx'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    getReceipt: function () {
      axios({
        method: 'get',
        url: urls({route: `record/${this.isEditing}/receipt`}),
        responseType: 'blob'
      }).then(function (resp) {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(resp.data)
        link.download = '匯出收據.docx'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    getExport: function () {
      axios({
        method: 'get',
        url: urls({route: `record/${this.isEditing}/record`}),
        responseType: 'blob'
      }).then(function (resp) {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(resp.data)
        link.download = '匯出服務紀錄.docx'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    useTemplate: async function (templateID) {
      let result = await axios.get(urls({route: `record-template/${templateID}`}))
      this.data.content = `${this.data.content}\n${result.data.data.content}`
      this.showUseTemplateDialog = false
    },
    readRecord: async function (recordID, isImport) {
      let req = await axios.get(urls({route: 'record', id: recordID}))
      // hack
      this.data = {
        ...req.data.data,
        is_completed: false,
        registered_at: null
      }
      if (this.data.ors_test) {
        this.loadOrsValues(this.data.ors_test.content)
      } else {
        this.resetOrsValues()
      }
      if (!isImport) {
        this.selectedDate = moment(req.data.data.registered_at[0]).format('YYYY-MM-DD')
        this.selectedStartTime = moment(req.data.data.registered_at[0]).get('hour')
      }
    },
    editRecord: async function () {
      let req = await axios.put(urls({route: 'record', id: this.isEditing}), {
        ...this.data,
        ors_test: {
          content: {
            ...this.ors,
            personal: this.ors.personal / 10,
            interpersonal: this.ors.interpersonal / 10,
            social: this.ors.social / 10,
            overall: this.ors.overall / 10
          }
        }
      })
      if (req.status === 200) {
        this.goRecordList()
      }
    },
    popupPatientInfo: async function () {
      const url = `${new URL(window.location).origin}/#/patient/${this.data.patient.id}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
textarea {
  min-height: 350px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Record/RecordEdit.vue